import { render, staticRenderFns } from "./BaseFormDate.vue?vue&type=template&id=896e728e&scoped=true"
import script from "./BaseFormDate.vue?vue&type=script&lang=js"
export * from "./BaseFormDate.vue?vue&type=script&lang=js"
import style0 from "./BaseFormDate.vue?vue&type=style&index=0&id=896e728e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896e728e",
  null
  
)

export default component.exports